import * as React from "react";
const SvgParts20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 2h16v14H1V2Zm2 2v10h12V4H3Zm6 2.586L11.414 9 9 11.414 6.586 9 9 6.586ZM20 19V7h-2v10H6v2h14Z",
      clipRule: "evenodd"
    })
  );
export default SvgParts20Px;
